import axios from 'axios';
import BaseAPI from './base/base-api';

class RoleAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'role';
}

export default new RoleAPI();